import { Component, OnInit, ViewChild } from '@angular/core';
import { FirebaseService } from 'src/app/services/firebase.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AngularFireStorage } from '@angular/fire/storage';
import { Router } from '@angular/router';

@Component({
  selector: 'app-manageorders',
  templateUrl: './manageorders.component.html',
  styleUrls: ['./manageorders.component.css']
})
export class ManageordersComponent implements OnInit {

  displayedColumns: string[] = ['uid','pid','total','payid','action'];
  dataSource : MatTableDataSource<any[]>;

    
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  constructor(private firebase: FirebaseService, private afs:AngularFireStorage, private router: Router) {
    this.firebase.getOrders().subscribe( res => {
      this.dataSource=new MatTableDataSource<any>(res);
      this.dataSource.paginator = this.paginator;
    });
   }

  ngOnInit(): void {
  }
  
  goDelete(id){
    this.firebase.deleteOrder(id);
  }

}
